import { usePartsInventory, useDocumentsCatalog } from "../hooks/useCatalogs";

/**
 * Loads the parts and documents catalogs in the background as soon as the application opens, so a
 * picker never has to wait for them. Renders nothing, and keeps the queries observed so they are
 * not dropped from memory while the user works.
 */
export const CatalogsPrefetch = () => {
	usePartsInventory();
	useDocumentsCatalog();
	return null;
};
